import SelectorEmpresas from '../SelectorEmpresas';

export const databaseSchema = {
  fields: [
    {
      name: 'idsucutien',
      type: 'custom',
      component: SelectorEmpresas,
      label: 'Empresa',
      required: true,
      gridSpan: 'full'
    },
    {
      name: 'host',
      type: 'text',
      label: 'Host/Servidor',
      required: true,
      placeholder: 'ej: localhost, 192.168.1.100, mi-servidor.com',
      gridSpan: 'auto',
    },
    {
      name: 'port',
      type: 'text',
      label: 'Puerto',
      required: true,
      placeholder: 'ej: 5432',
      gridSpan: 'auto'
    },
    {
      name: 'dbapostgres',
      type: 'text',
      label: 'Nombre Base de Datos',
      required: true,
      placeholder: 'ej: desarrollo, produccion, contabilidad',
      gridSpan: 'auto'
    },
    {
      name: 'sslmode',
      type: 'text',
      label: 'Nombre ssl mode',
      required: true,
      placeholder: 'ej: disable, allow, prefer, require, verify-ca, verify-full',
      gridSpan: 'auto'
    }
  ]
};